export const TYPES_OF_MESSAGES = {
  CHAT: "chat",
  FORM: "job_requirements_form",
  FILE: "file",
  OUTREACH: "outreach",
  SOURCING_DONE : "sourcing_done",
  SOURCING_ZERO_RESULTS : "sourcing_zero_results",
  SOURCING_PROGRESS : "sourcing_progress",
  SOURCING_CANCELLED : "sourcing_cancelled",
  SOURCING_ERROR : "sourcing_error",
  RESUME : "resume_upload",
  RELOCATION_QUESTION: "relocation_question",
  COMPONENT: "component",
  COMPONENT_ACTION: "component_action",
};

export const COMPONENT_TYPES = {
  JOB_LIST: "job_list",
  JOB_DETAIL_CARD: "job_detail_card",
  CANDIDATE_LIST: "candidate_list",
  CANDIDATE_DETAIL_CARD: "candidate_detail_card",
  INDUSTRY_SEARCH: "industry_search",
  COMPANY_FILTER: "company_filter",
};

export const ACTION_STYLES = {
  primary: "primary",
  secondary: "secondary",
  ghost: "ghost",
};

export const TYPES_OF_SENDER = {
  USER: "user",
  AI: "assistant",
  SYSTEM: "system",
  ERROR: "error",
};

export const SAMPLE_MESSAGES = [
  {
    type: TYPES_OF_MESSAGES.FORM,
    payload: {
      role: TYPES_OF_SENDER.AI,
        fields: [
          {
            fieldName: "job_title",
            value:
              "Logistics Accelerated Management Program (LAMP) - Finance Track",
          },
          {
            fieldName: "location",
            value: "Multiple locations",
          },
          {
            fieldName: "relocation",
            value: "Not mentioned",
          },
          {
            fieldName: "minexp",
            value: "Not specified",
          },
          {
            fieldName: "maxexp",
            value: "Not specified",
          },
          {
            fieldName: "must_have_skills",
            value:
              "financial operations, accounting, statutory compliance, direct taxes, indirect taxes, invoicing, financial statements, IND-AS, internal audit, external audit, statutory reporting, regulatory compliance, KPIs, financial MIS, accounting principles, tax rules, financial regulations",
          },
          {
            fieldName: "nice_to_have",
            value: "",
          },
        ],
    },
  },

  {
    type : TYPES_OF_MESSAGES.OUTREACH,
    payload : {
      role : TYPES_OF_SENDER.AI,
      content : "Hello"
    }
  }
];

export const FIELD_TYPES = {
  JOBTITLE: "job_title",
  LOCATION: "location",
  RELOCATION: "relocation",
  MINEXPERIENCE: "minexp",
  MAXEXPERIENCE: "maxexp",
  SKILLS: "musthaveskills",
  NICETOHAVE: "nicetohavenew",
};
